import { c as _c } from "react/compiler-runtime";
import { client } from "../../../shared/utils/thirdweb.js";
import { useQuery } from "@tanstack/react-query";
import createDebug from "debug";
import { getAllActiveSigners } from "thirdweb/extensions/erc4337";
const debug = createDebug("@@b3:useGetAllTWSigners");
export function useGetAllTWSigners(t0) {
  const $ = _c(11);
  const {
    chain,
    accountAddress,
    queryOptions
  } = t0;
  const t1 = chain?.id;
  let t2;
  if ($[0] !== accountAddress || $[1] !== t1) {
    t2 = ["useGetAllTWSigners", t1, accountAddress];
    $[0] = accountAddress;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== accountAddress || $[4] !== chain) {
    t3 = async () => {
      if (!chain || !accountAddress) {
        return [];
      }
      debug("@@getAllActiveSigners:start");
      const signers = await getAllActiveSigners({
        contract: {
          client,
          chain,
          address: accountAddress
        }
      });
      await new Promise(_temp);
      let sessionKeysMetadata;
      sessionKeysMetadata = {};
      ;
      try {
        const response = await fetch(`https://partner-session-keys-production.sean-430.workers.dev/?address=${accountAddress}&timestamp=${Date.now()}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (response.ok) {
          const data = await response.json();
          sessionKeysMetadata = data.keys.reduce(_temp2, {});
        }
      } catch (t4) {
        const error = t4;
        debug("Error fetching session keys metadata:", error);
      }
      if (!signers || !Array.isArray(signers) || signers.length === 0) {
        debug("@@useGetAllTWSigners:no signers");
        return [];
      }
      const result = signers.map(signer => {
        const metadata = sessionKeysMetadata[signer.signer];
        return {
          ...signer,
          id: signer.signer,
          metadata,
          partner: {
            id: metadata?.partnerId || signer.signer,
            name: metadata?.partnerInfo?.name || ""
          },
          createdAt: metadata ? new Date(metadata.timestamp).toISOString() : ""
        };
      });
      return result;
    };
    $[3] = accountAddress;
    $[4] = chain;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = queryOptions?.enabled !== false && Boolean(chain && accountAddress);
  let t5;
  if ($[6] !== queryOptions || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      ...queryOptions,
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 0
    };
    $[6] = queryOptions;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return useQuery(t5);
}
function _temp2(acc, key) {
  acc[key.sessionKey] = key;
  return acc;
}
function _temp(resolve) {
  return setTimeout(resolve, 500);
}